var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _vm.hasAnyRole("ROLE_ADMIN", "ROLE_USER_READ", "ROLE_USER_ADMIN")
        ? _c(
            "div",
            { staticClass: "col-md-10 pt-3" },
            [
              _c("toast", { ref: "toast" }),
              _vm._v(" "),
              _vm.hasAnyRole("ROLE_ADMIN", "ROLE_USER_ADMIN")
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-info m-2",
                      on: { click: _vm.goNew }
                    },
                    [
                      _c("i", { staticClass: "fa fa-child mr-1" }),
                      _vm._v("新規登録")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "form-group mr-3" }, [
                _c("span", { staticStyle: { "margin-left": "15px" } }, [
                  _vm._v("部署")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedDepartmentId,
                        expression: "selectedDepartmentId"
                      }
                    ],
                    staticClass: "search-select custom-select",
                    attrs: { name: "department" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedDepartmentId = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.changeSelected
                      ]
                    }
                  },
                  [
                    _vm.hasAnyRole("ROLE_ADMIN", "ROLE_MANAGE")
                      ? _c(
                          "option",
                          { attrs: { value: "", selected: "selected" } },
                          [_vm._v("すべて")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.loginUser.departmentList, function(
                      current,
                      index
                    ) {
                      return _c(
                        "option",
                        {
                          key: index,
                          domProps: {
                            value: _vm.loginUser.departmentIdList[index]
                          }
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(current) +
                              "\n          "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("label", { ref: "viewAll" }, [
                _c("input", {
                  attrs: { type: "checkbox", id: "viewAll" },
                  on: { click: _vm.checkUserView }
                }),
                _vm._v("退職者も表示")
              ]),
              _vm._v(" "),
              _vm.hasAnyRole("ROLE_ADMIN", "ROLE_USER_ADMIN")
                ? _c(
                    "button",
                    {
                      staticClass: "btn m-2",
                      class: { retiree: _vm.retireeMode },
                      staticStyle: {
                        background: "#7592BA",
                        "border-radius": "30px",
                        color: "#fff",
                        float: "right"
                      },
                      on: { click: _vm.retiree }
                    },
                    [_vm._v("退職手続き")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userList.length === 0
                ? _c("p", [_vm._v("まだデータがありません")])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "table",
                { staticClass: "table table-bordered table-responsive" },
                [
                  _c("thead", { staticClass: "thead-light" }, [
                    _c("tr", [
                      _c("th", [_vm._v("氏名")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("メール")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("部署")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("シフト")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("労働時間単位")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("権限")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("入社日")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("研修期間")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("有休発生日")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("緊急連絡先")]),
                      _vm._v(" "),
                      _vm.hasAnyRole("ROLE_ADMIN", "ROLE_USER_ADMIN")
                        ? _c("th", [_vm._v("操作")])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.userList, function(result) {
                      return _vm.viewAll || result.deletedAt == null
                        ? _c(
                            "tr",
                            {
                              key: result.userId,
                              class: { retiree: result.deletedAt }
                            },
                            [
                              _c("td", { staticClass: "noflap" }, [
                                _c("img", {
                                  staticClass: "card-img-top icon",
                                  attrs: {
                                    src: result.imageUrl ? result.imageUrl : "",
                                    onerror:
                                      "this.src='/src/assets/img/not_found_user_icon.jpg';"
                                  }
                                }),
                                _vm._v(" "),
                                _vm.hasAnyRole("ROLE_ADMIN", "ROLE_USER_ADMIN")
                                  ? _c("span", { staticClass: "noflap" }, [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "/admin/user/edit/" +
                                              result.userId
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(result.userName) +
                                              "\n                      "
                                          )
                                        ]
                                      )
                                    ])
                                  : _c("span", { staticClass: "noflap" }, [
                                      _vm._v(_vm._s(result.userName))
                                    ]),
                                _vm._v(" "),
                                result.birthday
                                  ? _c("span", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(
                                            _vm._f("age")(result.birthday)
                                          ) +
                                          ")"
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(result.mail))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    result.unit && result.unit.length > 10
                                      ? result.unit.slice(0, 10) + "..."
                                      : result.unit
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(result.defaultWorkShiftName))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(result.defaultWorkTimeInterval))
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                _vm._l(result.roleName.split(","), function(
                                  role
                                ) {
                                  return result.roleName
                                    ? _c("span", { key: role }, [
                                        role.endsWith("神権限")
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-primary",
                                                staticStyle: {
                                                  "background-image":
                                                    "linear-gradient(to top left, #F7DE05, #DA8E00, #EDAC06, #F7DE05, #ECB802, #DAAF08, #B67B03)"
                                                }
                                              },
                                              [_vm._v(_vm._s(role))]
                                            )
                                          : role.endsWith("フル権限")
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-primary"
                                              },
                                              [_vm._v(_vm._s(role))]
                                            )
                                          : role.endsWith("管理") ||
                                            role.endsWith("マネジメント権限")
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-success"
                                              },
                                              [_vm._v(_vm._s(role))]
                                            )
                                          : !role.endsWith("管理") &&
                                            !role.endsWith("フル権限")
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-secondary"
                                              },
                                              [_vm._v(_vm._s(role))]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e()
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "noflap" }, [
                                _vm._v(_vm._s(result.hireDate))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "noflap text-right" }, [
                                _vm._v(_vm._s(result.trainingMonth) + "ヶ月")
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "noflap" }, [
                                _vm._v(_vm._s(result.yukyuStartDate))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(result.emergencyContact))
                              ]),
                              _vm._v(" "),
                              _vm.hasAnyRole("ROLE_ADMIN", "ROLE_USER_ADMIN")
                                ? _c("td", [
                                    result.userWorkRegistrationList.length == 0
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-sm btn-outline-info",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                return _vm.goWorkRegistrarionCreate(
                                                  result.userId
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-edit"
                                            }),
                                            _vm._v("勤務登録")
                                          ]
                                        )
                                      : _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-sm btn-info",
                                            attrs: {
                                              type: "button",
                                              "data-toggle": "modal",
                                              "data-target":
                                                "#registration" + result.userId
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.showRegistrarion(
                                                  result.userId
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-book"
                                            }),
                                            _vm._v("勤務登録")
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "modal fade",
                                        attrs: {
                                          id: "registration" + result.userId,
                                          tabindex: "-1",
                                          role: "dialog",
                                          "aria-labelledby":
                                            "exampleModal3Label",
                                          "aria-hidden": "true"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "modal-dialog modal-lg",
                                            attrs: { role: "document" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "modal-content" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "modal-header"
                                                  },
                                                  [
                                                    _c(
                                                      "h5",
                                                      {
                                                        staticClass:
                                                          "modal-title mr-2",
                                                        attrs: {
                                                          id:
                                                            "exampleModal3Label"
                                                        }
                                                      },
                                                      [_vm._v("勤務登録確認")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-sm btn-outline-info",
                                                        attrs: {
                                                          type: "button",
                                                          "data-dismiss":
                                                            "modal",
                                                          "aria-label": "Close"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.goWorkRegistrarionCreate(
                                                              result.userId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-edit"
                                                        }),
                                                        _vm._v("新規")
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._m(0, true)
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "modal-body" },
                                                  [
                                                    result.isRegistrationView
                                                      ? _c(
                                                          "user-work-registration-view-summary",
                                                          {
                                                            attrs: {
                                                              result: result,
                                                              loginUser:
                                                                _vm.loginUser
                                                            }
                                                          }
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    result.userId != _vm.loginUser.userId
                                      ? _c("span", [
                                          _vm.retireeMode
                                            ? _c("span", [
                                                result.deletedAt == null
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-sm btn-outline-info",
                                                        attrs: {
                                                          type: "button",
                                                          "data-toggle":
                                                            "modal",
                                                          "data-target":
                                                            "#retiree-modal-" +
                                                            result.userId
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-minus-circle"
                                                        }),
                                                        _vm._v("退職")
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("date")(
                                                            result.deletedAt
                                                          )
                                                        ) + " 退職済み"
                                                      )
                                                    ])
                                              ])
                                            : _c("span", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-sm btn-outline-danger",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deleteUser(
                                                          result.userId
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-trash"
                                                    }),
                                                    _vm._v("削除")
                                                  ]
                                                )
                                              ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "modal fade",
                                        attrs: {
                                          id: "retiree-modal-" + result.userId,
                                          tabindex: "-1",
                                          role: "dialog",
                                          "aria-hidden": "true"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "modal-dialog",
                                            attrs: { role: "document" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "modal-content" },
                                              [
                                                _vm._m(1, true),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "modal-body" },
                                                  [
                                                    _c(
                                                      "form",
                                                      {
                                                        on: {
                                                          submit: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.retireeUser(
                                                              result.userId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-group"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v("氏名")
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  result.userName
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-group"
                                                          },
                                                          [
                                                            _vm._m(2, true),
                                                            _vm._v(" "),
                                                            !_vm.retireeDate
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "日付を選んでください"
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "el-date-picker",
                                                                  {
                                                                    class: {
                                                                      "border border-danger": !_vm.retireeDate
                                                                    },
                                                                    attrs: {
                                                                      type:
                                                                        "date",
                                                                      placeholder:
                                                                        "日付を選んでください"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.retireeDate,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.retireeDate = $$v
                                                                      },
                                                                      expression:
                                                                        "retireeDate"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-primary",
                                                            attrs: {
                                                              type: "submit"
                                                            }
                                                          },
                                                          [_vm._v("退職")]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [
        _vm._v("退職日を登録してください")
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("退職日"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14e58cf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14e58cf2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/admin/user/UserList.vue
// module id = 435
// module chunks = 0